/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Sections_Giveawaystats1Inputs */

const id_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik Giveaway`)
};

const ms_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik Pemberian`)
};

const da_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway Statistik`)
};

const de_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway-Statistiken`)
};

const en_us2_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway Stats`)
};

const es_es2_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas de regalos`)
};

const es_mx2_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas de regalos`)
};

const fil_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadistika ng Giveaway`)
};

const fr_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiques des gratuités`)
};

const it_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiche giveaway`)
};

const hu_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajándék statisztikák`)
};

const nl_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway-statistieken`)
};

const no_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway-statistikk`)
};

const pl_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statystyki rozdań`)
};

const pt_br2_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas de jogos grátis`)
};

const pt_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas de ofertas grátis`)
};

const ro_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistici oferte gratuite`)
};

const fi_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmaisjakotilastot`)
};

const sv_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utlottningsstatistik`)
};

const vi_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê tặng miễn phí`)
};

const tr_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedava Oyun İstatistikleri`)
};

const cs_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiky výprodejů`)
};

const bg_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика на безплатните игри`)
};

const ru_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика раздач`)
};

const uk_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика роздач`)
};

const ar_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إحصائيات الهدايا`)
};

const hi_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गिवअवे आँकड़े`)
};

const th_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถิติของแจกฟรี`)
};

const ja_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配布統計`)
};

const zh_cn2_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赠送统计`)
};

const zh_hant1_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`贈送統計`)
};

const ko_home_sections_giveawaystats1 = /** @type {(inputs: Home_Sections_Giveawaystats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 배포 통계`)
};

/**
* | output |
* | --- |
* | "Giveaway Stats" |
*
* @param {Home_Sections_Giveawaystats1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_sections_giveawaystats1 = /** @type {((inputs?: Home_Sections_Giveawaystats1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Sections_Giveawaystats1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_sections_giveawaystats1(inputs)
	if (locale === "ms") return ms_home_sections_giveawaystats1(inputs)
	if (locale === "da") return da_home_sections_giveawaystats1(inputs)
	if (locale === "de") return de_home_sections_giveawaystats1(inputs)
	if (locale === "en-US") return en_us2_home_sections_giveawaystats1(inputs)
	if (locale === "es-ES") return es_es2_home_sections_giveawaystats1(inputs)
	if (locale === "es-MX") return es_mx2_home_sections_giveawaystats1(inputs)
	if (locale === "fil") return fil_home_sections_giveawaystats1(inputs)
	if (locale === "fr") return fr_home_sections_giveawaystats1(inputs)
	if (locale === "it") return it_home_sections_giveawaystats1(inputs)
	if (locale === "hu") return hu_home_sections_giveawaystats1(inputs)
	if (locale === "nl") return nl_home_sections_giveawaystats1(inputs)
	if (locale === "no") return no_home_sections_giveawaystats1(inputs)
	if (locale === "pl") return pl_home_sections_giveawaystats1(inputs)
	if (locale === "pt-BR") return pt_br2_home_sections_giveawaystats1(inputs)
	if (locale === "pt") return pt_home_sections_giveawaystats1(inputs)
	if (locale === "ro") return ro_home_sections_giveawaystats1(inputs)
	if (locale === "fi") return fi_home_sections_giveawaystats1(inputs)
	if (locale === "sv") return sv_home_sections_giveawaystats1(inputs)
	if (locale === "vi") return vi_home_sections_giveawaystats1(inputs)
	if (locale === "tr") return tr_home_sections_giveawaystats1(inputs)
	if (locale === "cs") return cs_home_sections_giveawaystats1(inputs)
	if (locale === "bg") return bg_home_sections_giveawaystats1(inputs)
	if (locale === "ru") return ru_home_sections_giveawaystats1(inputs)
	if (locale === "uk") return uk_home_sections_giveawaystats1(inputs)
	if (locale === "ar") return ar_home_sections_giveawaystats1(inputs)
	if (locale === "hi") return hi_home_sections_giveawaystats1(inputs)
	if (locale === "th") return th_home_sections_giveawaystats1(inputs)
	if (locale === "ja") return ja_home_sections_giveawaystats1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_sections_giveawaystats1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_sections_giveawaystats1(inputs)
	return ko_home_sections_giveawaystats1(inputs)
});
export { home_sections_giveawaystats1 as "home.sections.giveawayStats" }